<div id="form-field-information-modal" class="modal-docked-right">
  <div class="modal-content-for-information">
    <main>
      <p>Please click the pin button on modal to dock the dialog.</p>
    </main>
  </div>
</div>

